"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bookmark = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Bookmark = function () {
    return (react_1.default.createElement("path", { fill: "currentColor", d: "M20 21a1 1 0 01-1.53.85l-5.94-3.72a1 1 0 00-1.06 0l-5.94 3.72A1 1 0 014 21V4a2 2 0 012-2h12a2 2 0 012 2v17z" }));
};
exports.Bookmark = Bookmark;
//# sourceMappingURL=bookmark.js.map